import * as d3 from 'd3';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ThemeService } from '@wind-log_library/fe-component-library';

@Component({
    selector: 'app-wind-nacelle-direction',
    templateUrl: './wind-nacelle-direction.component.html',
    standalone: false
})
export class WindNacelleDirectionComponent implements OnInit, OnChanges {

  @Input() windDirectionAngle: number;
  @Input() nacelleDirectionAngle: number;
  private clockRadius = 20;
  private margin = 2;
  private width = (this.clockRadius + this.margin) * 2;
  private height = (this.clockRadius + this.margin) * 2;
  private hourTickStart = this.clockRadius;
  private hourTickLength = -(this.clockRadius / 4);
  private mode = '';

  constructor(private themeService: ThemeService) { }
  ngOnInit(){
    this.themeService.getTheme().subscribe(d=>{
      d3.select('svg.wind-nacelle-direction').remove();
      this.mode = d;
      this.drawClock();
    });
  }

  ngOnChanges() {
    d3.select('svg.wind-nacelle-direction').remove();
    this.drawClock();
  }

  public calculateCoordinates(angleDegs, radius, margin) {
    const angleRadians = (angleDegs + 270) * 0.0174532925;
    const x1 = radius + margin + (radius * Math.cos(angleRadians));
    const y1 = radius + margin + (radius * Math.sin(angleRadians));
    return [x1, y1];
  }

  public drawClock() {
  const svg = d3.selectAll('.wndHolder').append('svg')
    .attr('class', 'wind-nacelle-direction')
    .attr('width', this.width)
    .attr('height', this.height)
    .attr('stroke', '#c2d1da')
    .attr('stroke-width', 2);

  const angle1 = this.nacelleDirectionAngle;
  const angle2 = this.windDirectionAngle;
  const arrowOne = this.calculateCoordinates(angle1, this.clockRadius, this.margin);
  const arrowTwo = this.calculateCoordinates(angle2, this.clockRadius, this.margin);
  const hourScale = d3.scaleLinear().range([0, 360]).domain([0, 8]);

  const defs = svg.append('defs');
  defs
    .append('pattern')
    .attr('id', 'arrow')
    .attr('width', 12)
    .attr('height', 12)
    .attr('patternUnits', 'objectBoundingBox')
    .append('image')
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', 12)
    .attr('height', 12)
    .attr('xlink:href', 'assets/shared/wind-nacelle-direction/arrow.svg');
  defs
    .append('pattern')
    .attr('id', 'arrow_light')
    .attr('width', 12)
    .attr('height', 12)
    .attr('patternUnits', 'objectBoundingBox')
    .append('image')
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', 12)
    .attr('height', 12)
    .attr('xlink:href', 'assets/shared/wind-nacelle-direction/arrow_light.svg');

  defs
    .append('pattern')
    .attr('id', 'arrow2')
    .attr('width', 12)
    .attr('height', 12)
    .attr('patternUnits', 'objectBoundingBox')
    .append('image')
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', 12)
    .attr('height', 12)
    .attr('xlink:href', 'assets/shared/wind-nacelle-direction/arrow2.svg');

  const circle = svg.append('circle')
    .attr('cx', this.clockRadius + this.margin)
    .attr('cy', this.clockRadius + this.margin)
    .attr('r', this.clockRadius)
    .attr('fill', 'none');

  const face = svg.append('g')
    .attr('id', 'clock-face')
    .attr('transform', 'translate(' + (this.clockRadius + this.margin) + ',' + (this.clockRadius + this.margin) + ')');

  face.selectAll('.hour-tick')
    .data(d3.range(0, 12)).enter()
    .append('line')
    .attr('class', 'hour-tick')
    .attr('x1', 0)
    .attr('x2', 0)
    .attr('y1', -this.clockRadius)
    .attr('y2', -this.clockRadius + this.clockRadius / 4)
    .attr('transform', (d) => {
      return 'rotate(' + hourScale(d) + ')';
    });

  svg.append('rect')
    .attr('x', arrowOne[0] - 6)
    .attr('y', arrowOne[1] + this.clockRadius)
    .attr('width', 12)
    .attr('height', 12)
    .attr('transform', () => {
      return 'rotate(' + angle1 + ', ' + arrowOne[0] + ', ' + arrowOne[1] + ')';
    })
    .style('stroke', 'none')
    .attr('fill', this.mode === 'dark' ? 'url(#arrow2)' : 'url(#arrow)');

  svg.append('rect')
    .attr('x', arrowTwo[0] - 6)
    .attr('y', arrowTwo[1] + this.clockRadius)
    .attr('width', 12)
    .attr('height', 12)
    .attr('transform', () => {
      return 'rotate(' + angle2 + ', ' + arrowTwo[0] + ', ' + arrowTwo[1] + ')';
    })
    .style('stroke', 'none')
    .attr('fill', 'url(#arrow_light)');
}

  public drawClock2() {
    const svg = d3.selectAll('.wndHolder').append('svg')
      .attr('class', 'wind-nacelle-direction')
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('stroke', '#c2d1da')
      .attr('stroke-width', 2);

    const angle1 = this.nacelleDirectionAngle;
    const angle2 = this.windDirectionAngle;
    const arrowOne = this.calculateCoordinates(angle1, this.clockRadius, this.margin);
    const arrowTwo = this.calculateCoordinates(angle2, this.clockRadius, this.margin);
    const hourScale = d3.scaleLinear().range([0, 360]).domain([0, 8]);

    const defs = svg.append('defs');
    defs
      .append('pattern')
      .attr('id', 'arrow')
      .attr('width', 24)
      .attr('height', 24)
      .attr('patternUnits', 'objectBoundingBox')
      .append('image')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', 24)
      .attr('height', 24)
      .attr('xlink:href', 'assets/shared/wind-nacelle-direction/arrow.svg');
    defs
      .append('pattern')
      .attr('id', 'arrow_light')
      .attr('width', 24)
      .attr('height', 24)
      .attr('patternUnits', 'objectBoundingBox')
      .append('image')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', 24)
      .attr('height', 24)
      .attr('xlink:href', 'assets/shared/wind-nacelle-direction/arrow_light.svg');

      defs
      .append('pattern')
      .attr('id', 'arrow2')
      .attr('width', 24)
      .attr('height', 24)
      .attr('patternUnits', 'objectBoundingBox')
      .append('image')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', 24)
      .attr('height', 24)
      .attr('xlink:href', 'assets/shared/wind-nacelle-direction/arrow2.svg');

    const circle = svg.append('circle')
      .attr('cx', this.clockRadius + this.margin)
      .attr('cy', this.clockRadius + this.margin)
      .attr('r', this.clockRadius)
      .attr('fill', 'none');

    const face = svg.append('g')
      .attr('id', 'clock-face')
      .attr('transform', 'translate(' + (this.clockRadius + this.margin) + ',' + (this.clockRadius + this.margin) + ')');

    face.selectAll('.hour-tick')
      .data(d3.range(0, 12)).enter()
      .append('line')
      .attr('class', 'hour-tick')
      .attr('x1', 0)
      .attr('x2', 0)
      .attr('y1', this.hourTickStart)
      .attr('y2', this.hourTickStart + this.hourTickLength)
      .attr('transform', (d) => {
        return 'rotate(' + hourScale(d) + ')';
      });

    svg.append('rect')
      .attr('x', arrowOne[0] - 12)
      .attr('y', arrowOne[1] + 40)
      .attr('width', 24)
      .attr('height', 24)
      .attr('transform', () => {
        return 'rotate(' + angle1 + ', ' + arrowOne[0] + ', ' + arrowOne[1] + ')';
      })
      .style('stroke', 'none')
      .attr('fill', this.mode === 'dark' ? 'url(#arrow2)': 'url(#arrow)');

    svg.append('rect')
      .attr('x', arrowTwo[0] - 12)
      .attr('y', arrowTwo[1] + 40)
      .attr('width', 24)
      .attr('height', 24)
      .attr('transform', () => {
        return 'rotate(' + angle2 + ', ' + arrowTwo[0] + ', ' + arrowTwo[1] + ')';
      })
      .style('stroke', 'none')
      .attr('fill', 'url(#arrow_light)');
  }

}
